import React from 'react';
import { Backdrop, makeStyles } from '@material-ui/core';
import waves from './animatedWaves.svg';

const useStyles = makeStyles(theme => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1
  }
}));

const LoadingScreen = ({ open = true, color = 'primary' }) => {
  const classes = useStyles();
  return (
    <Backdrop open={open} className={classes.backdrop}>
      <img src={waves} alt="loading" width="236" height="auto" />
    </Backdrop>
  );
};

export default LoadingScreen;
